module.exports = __webpack_public_path__ + "static/media/conocephalus_dorsalis_BD_001_APA.9ed93b06.mp3";